export interface DashboardStats {
  totalClients: number;
  paidClients: number;
  totalLeads: number;
  revenueSummary: number;
  activeSubscriptions: number;
}

export interface DashboardBirthday {
  userId: string;
  name: string;
  email: string;
  occupation: string | null;
  profilePictureUrl: string | null;
  dateOfBirth: string;
  daysUntil: number;
  birthdayLabel: string;
  isToday: boolean;
}

export interface SendBirthdayEmailResponse {
  userId: number;
  email: string;
  birthdayLabel: string;
  isToday: boolean;
}

export interface DashboardTask {
  id: string;
  taskId: string;
  title: string;
  assignee: {
    name: string;
    avatarUrl: string | null;
  };
  dueDate: string;
  status: string;
  completed: boolean;
}

export interface DashboardTasksGrouped {
  dueToday: { total: number; tasks: DashboardTask[] };
  dueTomorrow: { total: number; tasks: DashboardTask[] };
  dueIn7Days: { total: number; tasks: DashboardTask[] };
}

export interface DashboardTaskEmployeeOption {
  userId: number | null;
  name: string;
}

export interface DashboardTasksFilter {
  canViewAll: boolean;
  selectedAssigneeUserId: number | null;
  defaultAssigneeUserId: number | null;
  employees: DashboardTaskEmployeeOption[];
}

export interface DashboardTasksResult {
  filter: DashboardTasksFilter;
  tasks: DashboardTasksGrouped;
}

export const EMPTY_DASHBOARD_TASKS: DashboardTasksGrouped = {
  dueToday: { total: 0, tasks: [] },
  dueTomorrow: { total: 0, tasks: [] },
  dueIn7Days: { total: 0, tasks: [] },
};

export const EMPTY_DASHBOARD_TASKS_FILTER: DashboardTasksFilter = {
  canViewAll: false,
  selectedAssigneeUserId: null,
  defaultAssigneeUserId: null,
  employees: [],
};

export interface DashboardActivity {
  id: string;
  type: string;
  title: string;
  description: string;
  relativeTime: string;
  source: string;
  indicatorColor: string;
}

export interface DashboardAlert {
  id: string;
  title: string;
  message: string;
  severity: string;
}

export interface DashboardData {
  stats: DashboardStats;
  birthdays: DashboardBirthday[];
  tasks: DashboardTasksGrouped;
  activity: DashboardActivity[];
  alerts: DashboardAlert[];
}
